import React, {useEffect, useState} from 'react';
import EyeInTheSky from "./EyeInTheSky";
import {getSessionFacts} from "../Session/sessionFacts";
import {getParams} from "../lib/params";
import {resetLocalStorageCache} from "../Session/cachedLocalStorage";
import {buildFullyLoadedEvent, pushDataLayerEvent} from "../Analytics/GoogleDatalayer";

/**
 * This does some tasks at the initial load, before rendering EyeInTheSky
 * for the first time.
 *
 * @param props
 * @returns {JSX.Element|null}
 * @constructor
 */
export default function EyeInTheSkyStartupWrapper(props) {

  const [sessionFacts, setSessionFacts] = useState(null);

  useEffect(() => {
    const params = getParams();

    if (params['RESET']) {
      resetLocalStorageCache();
    }

    let sf = getSessionFacts({params});

    setSessionFacts(sf);

    // Update google data layer
    let event = buildFullyLoadedEvent({sessionFacts: sf})

    pushDataLayerEvent(event);

  }, [])

  // Render it ONLY when session facts are fully loaded
  if (sessionFacts) {
    return <EyeInTheSky {...props} sessionFacts={sessionFacts} />;
  }

  return null;
}



